var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enableBanner)?_c('b-row',{staticClass:"p-2 d-flex font-italic",staticStyle:{"background":"#fff3cd","max-width":"300px","border-radius":"10px"}},[_c('div',[_c('b-icon-exclamation-triangle-fill',{staticStyle:{"color":"black"}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('banner'))}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }